import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || ""; // "" = same-origin /api (self-hosted Caddy proxy)
const TOKEN_KEY = "aac_access_token";

export const getToken = () => {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
};
export const setToken = (t) => {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {/* ignore */}
};

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  // Always send cookies (httpOnly access_token cookie, set by /auth/login).
  // This is the primary auth mechanism going forward.
  config.withCredentials = true;
  // Legacy fallback: also inject Authorization: Bearer header from
  // localStorage so already-logged-in users from before the cookie
  // migration stay logged in until their 7-day token expires.
  // get_current_user on the backend reads the cookie first, header second.
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Global tier-gate handler. Backend's `tier_gate.py` returns HTTP 402 with
// `{detail: {code: "tier_upgrade_required", ...}}` when a Starter user hits
// an Individual-only feature. We dispatch a window event so the global
// <TierUpgradeListener /> in App.js can pop the upgrade modal once,
// regardless of which page triggered the call.
export const TIER_UPGRADE_EVENT = "sonspeak:tier-upgrade-required";

api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    if (status === 402 && detail && typeof detail === "object" && detail.code === "tier_upgrade_required") {
      try {
        window.dispatchEvent(new CustomEvent(TIER_UPGRADE_EVENT, { detail }));
      } catch { /* ignore */ }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
